import React, { useContext, useEffect, useState } from 'react';
import CallTableViewModel from '../../../ViewModels/CallTableViewModel';
import { APIContext } from '../../../Contexts/APIContext';
import InsightAnswerviewModel from './ViewModels/InsightAnswerViewModel';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function InsightDialog(props: IFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [templateOptions, setTemplateOptions] = useState<string[]>([]);
    const [questionOptions, setQuestionOptions] = useState<string[]>([]);
    const [insightFilter, setInsightFilter] = useState<InsightAnswerviewModel>(props.callTableViewModel.filters.insight);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.open) {
            setInsightFilter(props.callTableViewModel.filters.insight);
        }
    }, [props.open])

    useEffect(() => {
        getTemplateOptions();
    }, []);


    useEffect(() => {
        ClearOptions();
        if (insightFilter.channel !== '') getQuestionOptions();
    }, [insightFilter.channel]);

    //#region database calls
    const getTemplateOptions = () => {
        get('AIAnalysis', `GetInsightTemplateOptions?client=` + props.callTableViewModel.filters.client, (data) => {
            setTemplateOptions(data);
        });
    }

    const getQuestionOptions = () => {
        get('AIAnalysis', `GetInsightQuestionOptions?client=` + props.callTableViewModel.filters.client + `&channel=` + insightFilter.channel, (data) => {
            setQuestionOptions(data)
        });
    }
    //#endregion

    const ClearOptions = () => {
        setInsightFilter({
            ...insightFilter,
            question: "",
            answer: ""
        });
    }
    const HandleSelect = (key: string, value: string) => {
        setInsightFilter({
            ...insightFilter,
            [key]: value
        });
    }

    const HandleSelectAnswer = (key: string, value: string) => {
        setInsightFilter({
            ...insightFilter,
            answer: value
        });
    }

    const Confirm = () => {
        if (insightFilter.channel !== '' && insightFilter.question !== '' && insightFilter.answer !== '') {
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.insight = insightFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })
            props.setOpen(false);
        } else {
            enqueueSnackbar("All values must be selected to confirm", { variant: 'warning' });
        }
    }

    return (
        <Dialog onClose={() => props.setOpen(false)} open={props.open} fullWidth maxWidth="sm">
            <DialogTitle>Insight</DialogTitle>
            <DialogContent>
                {templateOptions.length > 0 ?
                    <Grid container style={{ width: '100%' }}>
                        <Grid size={12}>
                            <InputLabel>Channel</InputLabel>
                            <TextField
                                select
                                name="channel"
                                value={insightFilter.channel}
                                onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                fullWidth
                            >
                                {templateOptions.map((template: string) => {
                                    return (<MenuItem key={template} value={template}>{template}</MenuItem>);
                                })}
                            </TextField>
                        </Grid>

                        {insightFilter.channel !== '' &&
                            <Grid size={12}>
                                <InputLabel>Question</InputLabel>
                                <TextField
                                    select
                                    name="question"
                                    value={insightFilter.question}
                                    onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={insightFilter.channel === ''}
                                >
                                    {questionOptions.length > 0 && questionOptions.map((question: string) => {
                                        return (<MenuItem key={question} value={question}>{question}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {insightFilter.channel !== '' && insightFilter.question !== '' &&
                            <Grid size={12}>
                                <InputLabel>Answer</InputLabel>
                                <TextField
                                    select
                                    name="answer"
                                    value={insightFilter.answer}
                                    onChange={(e) => HandleSelectAnswer(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={insightFilter.channel === '' || insightFilter.question === ''}
                                >
                                    <MenuItem key={0} value="Yes">Yes</MenuItem>
                                    <MenuItem key={1} value="No">No</MenuItem>
                                    <MenuItem key={2} value="N/A">N/A</MenuItem>
                                </TextField>
                            </Grid>
                        }
                    </Grid>
                    :
                    <p>This AI Filter Is Not Used By This Client</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                {templateOptions.length > 0 &&
                    <Button onClick={Confirm} color="primary">Confirm</Button>
                }
            </DialogActions>
        </Dialog>
    )
}